import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Dashboard } from "@/pages/Dashboard";
import { NationalExecutiveDashboard } from "@/pages/NationalExecutiveDashboard";

/**
 * Phase XVI.1 — Executive Landing Default™
 * Additive wrapper for the /app index route. Executive-tier roles land on the
 * National Executive Dashboard™; all other users continue to see the existing
 * operational Dashboard (unchanged). Zero regression.
 */
const EXECUTIVE_ROLES = new Set([
  "national_executive", "executive", "sovereign_admin", "cadastre_administrator",
  "president", "vice_president", "first_vice_president", "second_vice_president",
  "chief_secretary", "cabinet_minister", "minister", "minister_of_state",
  "permanent_secretary", "treasury_executive", "treasury",
  "executive_government_administrator", "executive_administrator",
]);

export const ExecutiveLandingRouter = () => {
  const { user } = useAuth();
  const role = user?.role;
  if (role && EXECUTIVE_ROLES.has(role)) return <NationalExecutiveDashboard />;
  return <Dashboard />;
};

export default ExecutiveLandingRouter;
